import React from 'react';
import ErrorLabel from '../ErrorLabel';
import InnerLabel from '../InnerLabel';

export type SpreedlyFramedInputProps = {
  id: string;
  label: string;
  icon?: React.ReactNode;
  errorLabel: string | undefined;
};

export const SpreedlyFramedInputTestId = 'SpreedlyFramedInput-input';

const SpreedlyFramedInput: React.FC<SpreedlyFramedInputProps> = ({
  id,
  label,
  icon,
  errorLabel,
}: SpreedlyFramedInputProps) => {
  const baseClass = `peer w-full border-1-half rounded checkout-panel-form-input
                     outline-none`;
  return (
    <div className="m-2 relative">
      <InnerLabel
        inputName={id}
        hasErrors={Boolean(errorLabel)}
        className="absolute"
      >
        {label}
      </InnerLabel>
      <div
        data-testid={SpreedlyFramedInputTestId}
        id={id}
        className={`${baseClass} ${
          errorLabel ? 'input-error-border' : 'border-transparent'
        }`}
        style={{
          height: '3.2rem',
        }}
      />
      {icon}
      <ErrorLabel>{errorLabel}</ErrorLabel>
    </div>
  );
};

export default SpreedlyFramedInput;
